// --------------------------------------- Project List
export const ProjectList = [
  {
    img: process.env.PUBLIC_URL + "/google.png",
    title: "Play Store App Analytics Dashboard",
    description:
      "Analyzes Google Play Store app data, providing insights into app categories, ratings, installations, and update trends. Understand app popularity, user engagement, and the impact of free vs. paid apps. Perfect for developers, analysts, and marketers!",
    tech_stack: ["Python", "SQL", "Microsoft Excel", "Power BI"],
    github_url: "https://github.com/pavanKumarponna/Play-Store-App-Analytics-Dashboard",
    demo_url: "https://app.powerbi.com/links/GewatzlB7P?ctid=b637c4f6-57b7-44dc-bce4-fec0cd202460&pbi_source=linkShare",
  },
  {
    img: process.env.PUBLIC_URL + "/hr.png",
    title: "HR-Data-Driven-Insights",
    description:
      "The project analyzes HR-related data to uncover trends and generate actionable insights that can improve recruitment processes and employee retention strategies.",
    tech_stack: ["Power BI", "SQL", "Microsoft Excel"],
    github_url: "https://github.com/pavanKumarponna/HR-Data-Driven-Insights",
    demo_url: "https://app.powerbi.com/groups/me/reports/402b88b3-b2ac-4b68-a3d4-38a0b15a842f/aa1b45d917e348c1d081?ctid=b637c4f6-57b7-44dc-bce4-fec0cd202460&experience=power-bi",
  },
  {
    img: process.env.PUBLIC_URL + "/Road.png",
    title: "Road Accident Analysis",
    description:
      "Identify patterns and high-risk factors. It provides insights into accident types, affected vehicles, and time trends, aiding data-driven decision-making for public safety organizations and traffic departments.",
    tech_stack: ["Power BI", "Excel", "Pandas"],
    github_url: "https://github.com/pavanKumarponna/Road-Accident-Analysis-Power-BI-Project",
    demo_url: "https://app.powerbi.com/links/y2FrkwZbRN?ctid=b637c4f6-57b7-44dc-bce4-fec0cd202460&pbi_source=linkShare",
  },
  {
    img: process.env.PUBLIC_URL + "/pizza.png",
     title: "Pizza Sales Analysis",
    description:
      "Pizza sales data to identify key trends, top-selling products, and areas for potential growth. Gain insights into revenue, order patterns, and pizza category performance to optimize your business strategies.",
    tech_stack: ["SQL", "Power BI", "Excel", "Tableau"],
    github_url: "https://github.com/pavanKumarponna/-Pizza-Sales-Analysis",
    demo_url: "https://app.powerbi.com/links/VD7yTZnoR7?ctid=b637c4f6-57b7-44dc-bce4-fec0cd202460&pbi_source=linkShare",
  },
  {
    img: process.env.PUBLIC_URL + "/ml.png",
    title: "House Price Prediction",
    description:
      "Predicts house prices based on features like location and square footage.",
    tech_stack: ["Python", "Machine Learning", "Jupyter Notebook"],
    github_url: "https://github.com/pavanKumarponna/House-Price-Prediction",
    demo_url: "https://github.com/pavanKumarponna/House-Price-Prediction",
  },
];
